import { Logger } from "../../../../lib/logger/Logger";
import { supabase } from "../../../../lib/supabase";

export const getClientAvatar = async (
	avatar_path: string,
	organizationId: string
) => {
	const { data, error } = await supabase.storage
		.from("pub_img")
		.createSignedUrl(`${organizationId}/${avatar_path}`, 3600, {
			transform: {
				quality: 35,
			},
		});

	if (error) {
		Logger.error("Error fetching avatar");
		return;
	}

	return data.signedUrl;
};
